const listaDeCtrlCampos = (state) => {
    return state.items;
}

const loadingCampos = (state) => {
    return state.buscando
}

export {
    listaDeCtrlCampos,
    loadingCampos
}